import { PARTY, STATUS_LABEL, fmtVotes } from "./shared";
import { PartyLogo } from "./PartyLogo";

export function StatusBadge({ status, party, calledBy }) {
  const p = PARTY[party];
  const solid = status === "called" || status === "projected";
  const style = p ? (solid ? { background: p.solid, color: "#fff" } : { color: p.solid, borderColor: p.solid }) : {};
  const by = calledBy === "newsroom" ? " · Hinton" : calledBy === "auto" ? " · auto" : "";
  return (
    <span
      className={`inline-flex items-center px-2 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${p && !solid ? "border" : ""} ${!p ? "text-neutral-500 border border-neutral-300" : ""}`}
      style={style}
      data-testid="midterms-status-badge"
    >
      {p ? `${p.short} ${STATUS_LABEL[status] || ""}` : STATUS_LABEL.none}
      {p && by}
    </span>
  );
}

function CandidateRow({ c, top }) {
  const p = PARTY[c.party] || PARTY.I;
  const hasNumbers = c.votes > 0 || c.pct > 0;
  return (
    <li className="py-2" data-testid="midterms-candidate-row">
      <div className="flex items-center gap-2 text-sm">
        {(c.party === "D" || c.party === "R") && <PartyLogo party={c.party} size={18} />}
        <span className={`flex-1 min-w-0 truncate ${top ? "font-semibold" : ""}`}>
          {c.name}
          {c.incumbent && <span className="ml-1 text-[10px] text-neutral-400 uppercase tracking-wider">inc.</span>}
          {c.winner && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider" style={{ color: p.solid }}>Winner</span>}
        </span>
        {hasNumbers && <span className="tabular-nums font-semibold">{Number(c.pct).toFixed(1)}%</span>}
      </div>
      {hasNumbers && (
        <div className="mt-1 flex items-center gap-2">
          <div className="flex-1 h-1.5 bg-neutral-100">
            <div className="h-full transition-[width] duration-700" style={{ width: `${Math.min(100, c.pct)}%`, background: p.solid }} />
          </div>
          <span className="text-[10px] tabular-nums text-neutral-400 w-20 text-right">{fmtVotes(c.votes)}</span>
        </div>
      )}
    </li>
  );
}

export function RaceCard({ title, race, testid }) {
  if (!race) return null;
  const cands = (race.candidates || []).slice(0, 4);
  return (
    <div className="border-t border-black/10 pt-4" data-testid={testid}>
      <div className="flex items-center justify-between gap-3">
        <div className="overline text-neutral-500">
          {title}
          {race.special && <span className="ml-2 text-[var(--hinton-red)]">Special</span>}
        </div>
        <StatusBadge status={race.status} party={race.party} calledBy={race.called_by} />
      </div>
      {cands.length > 0 ? (
        <ul className="mt-2">
          {cands.map((c, i) => <CandidateRow key={c.name + i} c={c} top={i === 0} />)}
        </ul>
      ) : (
        <p className="mt-3 text-sm text-neutral-500 font-serif-ed italic">
          Results appear here as soon as counting starts. Seat currently held by the{" "}
          {PARTY[race.incumbent_party]?.name || "incumbent party"}.
        </p>
      )}
      <div className="mt-2 text-[11px] uppercase tracking-[0.14em] text-neutral-400 tabular-nums" data-testid="midterms-race-reporting">
        {race.total_votes || race.reporting_pct
          ? `${Number(race.reporting_pct || 0).toFixed(0)}% expected vote in${race.total_votes ? ` · ${fmtVotes(race.total_votes)} votes` : ""}`
          : race.status === "called"
            ? "Race called · state vote totals to follow"
            : "0% expected vote in"}
      </div>
    </div>
  );
}
